export default "__VITE_ASSET__Fq8nb8Mn__"